/* Add Bid functionality */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface IAddBidState {
    redirect: boolean;
    clientId?: number;
    clientContactId?: number;
    associationId?: number;
    projectManagerUserObjId?: string;
    siteInspectorUserObjId?: string;
}

const initialState: IAddBidState = {
    redirect: false,
    clientId: undefined,
    clientContactId: undefined,
    associationId: undefined,
    projectManagerUserObjId: undefined,
    siteInspectorUserObjId: undefined,
};

export function addBidReducer(state: IAddBidState = initialState, action: any): IAddBidState {
    switch (action.type) {
        case Actions.ADD_BID_REDIRECT:
            return _.merge({}, state, { redirect: action.value });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/addBidReducer.tsx